import { Component, Input } from '@angular/core';
import { DecidoEvaluationService } from 'src/app/core/decido-evaluation.service';
import { ErrorService } from 'src/app/core/error.service';
import { Order } from 'src/app/core/orders.service';

@Component({
  selector: 'app-order-details-decido-info',
  templateUrl: './order-details-decido-info.component.html',
  styleUrls: ['./order-details-decido-info.component.scss'],
})
export class OrderDetailsDecidoInfoComponent {
  @Input() order?: Order;

  is_read_running = false;
  decido_evaluation: any;
  current_type = 'bd1';

  constructor(private decido_evaluation_service: DecidoEvaluationService, private error_service: ErrorService) {}

  ngOnInit(): void {
    const bd1_id = this.order?.bd1_evaluation_id;
    const buyer_id = this.order?.buyer_id;
    if (bd1_id && buyer_id) this.readDecidoEvaluation(bd1_id, buyer_id);
  }

  onEvaluationChange(type: string): void {
    this.current_type = type;
    const buyer_id = this.order?.buyer_id;
    switch (type) {
      case 'bd1':
        const bd1_id = this.order?.bd1_evaluation_id;
        if (bd1_id && buyer_id) {
          this.readDecidoEvaluation(bd1_id, buyer_id);
        } else {
          this.decido_evaluation = undefined;
        }
        break;
      case 'bd2':
        const bd2_id = this.order?.bd2_evaluation_id;
        if (bd2_id && buyer_id) {
          this.readDecidoEvaluation(bd2_id, buyer_id);
        } else {
          this.decido_evaluation = undefined;
        }
        break;
      case 'bd5':
        const bd5_id = this.order?.bd5_evaluation_id;
        if (bd5_id && buyer_id) {
          this.readDecidoEvaluation(bd5_id, buyer_id);
        } else {
          this.decido_evaluation = undefined;
        }
        break;
      default:
        break;
    }
  }

  readDecidoEvaluation(decido_evaluation_id: string, buyer_id: string): void {
    this.is_read_running = true;
    this.decido_evaluation_service.read(decido_evaluation_id, buyer_id).subscribe({
      next: response => {
        this.decido_evaluation = response.data;
        this.is_read_running = false;
      },
      error: error => {
        this.decido_evaluation = undefined;
        this.error_service.processGenericApiError(error);
        this.is_read_running = false;
      },
    });
  }
}
